var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[(_vm.$root.authenticated)?_c('button',{staticClass:"ring active",attrs:{"title":"sign out"},on:{"click":_vm.signOut}}):_c('button',{staticClass:"ring",attrs:{"title":"sign in"},on:{"click":_vm.signIn}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa9c190","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/Auth.vue
// module id = Wn4H
// module chunks = 0